export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4682.e6a325fa.jpg";